export default __webpack_public_path__ + "static/media/48.4a9ed179.jpg";